import React from "react";
import translate from "../../reusable/translate";

const RealizedTypeMeter = ({ language }) => {
  return (
    <div className="flex-row margin-top-bot">
      <div className="w300" />
      <div className="w800">
        <p className="p">
          {translate({
            textKey: "sit.commitmentCreation.realizedMeterText.871646",
            languageOverride: language
          })}
        </p>
      </div>
    </div>
  );
};

export default RealizedTypeMeter;



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/meter/RealizedTypeMeter.jsx